<template>

    <div class="menu-wrapper has-text-grey-dark">

        <div class="menu-group" style="background-color:#f5967d;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Data Node Variables</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/extract-variable')" title="Extract a variable from the trigger or any imported data nodes.">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-file-export"></i></p>
                                <p class="is-size-7 has-text-weight-bold">EXTRACT VARIABLE</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/extract-relation')" title="Extract built in relationships from the trigger or any imported data nodes.">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-file-arrow-down"></i></p>
                                <p class="is-size-7 has-text-weight-bold">EXTRACT RELATION</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item" v-if="triggerType === 'updated'">
                    <div class="big-pretty-button" @click="selected('variables/extract-original-variable')" title="Extract the original variable from the updated trigger.">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-file-export"></i></p>
                                <p class="is-size-7 has-text-weight-bold">EXTRACT ORIGINAL VARIABLE</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="menu-group" style="background-color:#fd754b;">

            <div class="menu-group-title">
                <p title="Pull in new data nodes for consideration in your ">Data Nodes</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/user')" title="Select a user from all available users">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-user"></i></p>
                                <p class="is-size-7 has-text-weight-bold">USER</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/shop')" title="Select a shop from all available shops">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-screwdriver-wrench"></i></p>
                                <p class="is-size-7 has-text-weight-bold">SHOP</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/groups')" title="Select a group from all available groups">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-people-group"></i></p>
                                <p class="is-size-7 has-text-weight-bold">GROUP</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div class="menu-group" style="background-color:#ff7c69;">

            <div class="menu-group-title">
                <p title="Pull in new data nodes for consideration in your ">Dynamic Nodes</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/dynamic-group')" title="Select a group based on certain criteria">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-people-group"></i></p>
                                <p class="is-size-7 has-text-weight-bold">GROUP</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/dynamic-shop')" title="Select a shop based on certain criteria">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-screwdriver-wrench"></i></p>
                                <p class="is-size-7 has-text-weight-bold">SHOP</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('variables/dynamic-email-list')" title="Select an email list based on email">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-envelope"></i></p>
                                <p class="is-size-7 has-text-weight-bold">EMAIL LIST</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

<!--        <div class="menu-group" style="background-color:#bfb5b2;">-->

<!--            <div class="menu-group-title">-->
<!--                <p title="These split your code to do different things based on conditions you define">{{ $capitalize(trigger.type) }} {{ triggerInfo.name }} Variables</p>-->
<!--            </div>-->

<!--            <div class="menu-group-items">-->

<!--                <div class="menu-item" v-for=" i in Math.ceil(Object.keys(triggerInfo.properties).length / 4) ">-->

<!--                    <ul>-->
<!--                        <li v-for=" j in 4 " v-if=" (((i-1)*4) + j) < Object.keys(triggerInfo.properties).length">-->
<!--                            -->
<!--                            {{ Object.keys(triggerInfo.properties)[((i-1)*4) + j] }}-->
<!--                        </li>-->
<!--                    </ul>-->

<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

    </div>


</template>

<script>
export default {
    name: 'MenuTabModifiers',
    props: {
        triggerType: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        selected(type) {
            this.$emit('selected', type)
        }
    }
}
</script>

<style scoped lang="scss">
.menu-wrapper {
    overflow-x: auto;
    display: flex;
}
.menu-group {
    margin: 0 10px;
    padding: 10px;
    border-radius: 6px;

    .menu-group-title {
        width:100%;
        font-weight: bold;
        font-size: 1.5rem;
    }

    .menu-group-items {
        overflow-x: auto;
        display: flex;
    }

    &:first-child {
        margin-left: auto;
    }
    &:last-child {
        margin-right: auto;
    }
}
.menu-item {
    margin: 0 10px;

    & > div {
        padding: 0;
        height: 100px;
        width: 100px;
    }
}
.big-pretty-button {
    border: 0.5px solid #4a4a4a;
}
</style>
